import { render, staticRenderFns } from "./SerConcierge.vue?vue&type=template&id=0addeff0&"
import script from "./SerConcierge.vue?vue&type=script&lang=js&"
export * from "./SerConcierge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports